import React, { useState, useEffect } from 'react';
import API from '../../../pages/Api';
import { toast } from 'react-toastify';
import { FaEdit, FaPlus, FaTimes, FaTrash } from 'react-icons/fa';
import TableContainer from '../../common/Tablecontainer'; // 💡 Matches your architectural rules context

const ExpandedDescCell = ({ text }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const isMobile = window.innerWidth < 768;

    
        if (!text) return <span>-</span>;
        const shouldTruncate = text.length > 100;

    return (
        <div className="text-left py-1">
            <div className={!isExpanded && shouldTruncate ? "line-clamp-2 overflow-hidden" : "whitespace-pre-wrap break-words"}>
                {text}
            </div>
            {shouldTruncate && (
                <button 
                    type="button"
                    onClick={() => setIsExpanded(!isExpanded)} 
                    className="text-blue-600 text-[10px] font-bold mt-1 hover:underline bg-transparent border-none cursor-pointer transition-all duration-300 ease-in-out"
                >
                    {isExpanded ? '...read less' : '...read more'}
                </button>
            )}
        </div>
    );
};

const AddEventDetails = () => {
    const isMobile=window.innerWidth<768;

    const [list,setList]=useState([]);

    const [mobilePage,setMobilePage]=useState(1);

    const [mobileTotalPages,setMobileTotalPages]=useState(1);

    const [mobileTotalRecords,setMobileTotalRecords]=useState(0);

    const [loadingCards,setLoadingCards]=useState(false);

    const [events,setEvents]=useState([]);
        
    // const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    
    // Controlled modal states parameters
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedEventId, setSelectedEventId] = useState(null);

    // Form operational parameter fields configuration
    const [formData, setFormData] = useState({
        eventtitle: '',
        eventdesc: '',
        attachments: [] 
    });

    const loadEventRecords = async (
        page = mobilePage,
        search = searchQuery
    ) => {

        try {

            setLoadingCards(true);

            const res = await API.get(
                "admin/add-event/",
                {
                    params: {
                        page,
                        search,
                        type: "All"
                    }
                }
            );

            setList(res.data.results || []);
            setMobileTotalPages(
                Math.ceil((res.data.count || 0) / 10)
            );
            setMobileTotalRecords(res.data.count || 0);

        } catch (err) {

            console.log(err);

        } finally {

            setLoadingCards(false);

        }

    };

    useEffect(()=>{
        if(isMobile){
            loadEventRecords(1,searchQuery);
        }
    },[]);
    useEffect(()=>{

        if(!isMobile) return;

        const timer=setTimeout(()=>{

            setMobilePage(1);

            loadEventRecords(
                1,
                searchQuery
            );

        },500);

        return ()=>clearTimeout(timer);

    },[searchQuery]);
    useEffect(()=>{

        if(!isMobile) return;

        loadEventRecords(
            mobilePage,
            searchQuery
        );

    },[mobilePage]);

    const handleAddNewTrigger = ( refreshTable) => {
        setFormData({ eventtitle: '', eventdesc: '', attachments: [] });
        setIsEditMode(false);
        setIsModalOpen(true);
        window.activeTableRefresh = refreshTable;
    };

    const handleEditTrigger = async (item, refreshTable) => {
        setSelectedEventId(item.eventid);
        setIsEditMode(true);
        setIsModalOpen(true);
        window.activeTableRefresh = refreshTable;
        

        try {
            // 💡 1. Pull prior saved attachments using the fresh query-param API endpoint
            const res = await API.get(`admin/get-event-attachments/?eventId=${item.eventid}`);
            
            if (res.data.status === "Success" && res.data.attachmentData) {
                setFormData({
                    eventtitle: item.eventtitle || '',
                    eventdesc: item.eventdesc || '',
                    attachments: res.data.attachmentData // Hydrates table with prior records smoothly
                });
            } else {
                setFormData({ eventtitle: item.eventtitle || '', eventdesc: item.eventdesc || '', attachments: [] });
            }
        } catch (err) {
            console.error("Operational failure reloading contextual attachments array:", err);
            setFormData({ eventtitle: item.eventtitle || '', eventdesc: item.eventdesc || '', attachments: [] });
        }
    };

    const handleRecordDeleteTrigger = async (pk) => {
        if (!window.confirm("Are you completely sure you want to delete this event row?")) return;
        try {
            await API.delete(`admin/add-event/${pk}/`);
           loadEventRecords(
            mobilePage,
            searchQuery
            );
        } catch (err) { 
            console.error("Failure processing delete entity instruction:", err); 
        }
    };

    const handleFormSubmitAction = async (e) => {
        e.preventDefault();
        if (!formData.eventtitle || !formData.eventdesc) {
            toast.warn("Please complete required event parameters.");
            return;
        }

        const payload = new FormData();
        payload.append('eventtitle', formData.eventtitle);
        payload.append('eventdesc', formData.eventdesc);
        
        // If in edit mode, append eventid straight into the FormData payload matrix
        if (isEditMode && selectedEventId) {
            payload.append('eventid', selectedEventId);
        }
        
        // 💡 2. Loop and attach files metadata variables matching backend indexing sequence precisely
        formData.attachments.forEach((att, idx) => {
            payload.append(`attachments[${idx}][description]`, att.description);
            
            if (att.file) {
                // If it's a freshly chosen file binary object
                payload.append(`attachments[${idx}][file]`, att.file);
            } else if (att.existingFileName) {
                // If it's a previously stored filename string key tracking reference
                payload.append(`attachments[${idx}][existingFileName]`, att.existingFileName);
            }
        });

        try {
            setLoading(true);
            const res = await API.post('admin/add-event/', payload, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            if (res.data.status === "Success") {
                toast.success(isEditMode ? "Event updated smoothly." : "New event added successfully.");
            }
            
            setIsModalOpen(false);
            loadEventRecords(
            mobilePage,
            searchQuery
            );
        } catch (err) {
            console.error("Operational crash executing submit payload mapping stack:", err);
            toast.error("API failed to execute configuration.");
        } finally {
            setLoading(false);
        }
    };

    const addAttachmentRow = () => {
        setFormData({
            ...formData,
            attachments: [...formData.attachments, { description: '', file: null, existingFileName: '' }]
        });
    };

    const removeAttachmentRow = (idx) => {
        setFormData({
            ...formData,
            attachments: formData.attachments.filter((_, i) => i !== idx)
        });
    };

    // const filteredEvents = events.filter(item => 
    //     item.eventdesc?.toLowerCase().includes(searchQuery.toLowerCase()) || 
    //     item.eventtitle?.toLowerCase().includes(searchQuery.toLowerCase())
    // );

    const gridHeaders = ['EVENT DESCRIPTION', 'EVENT TITLE', 'ACTION'];

    return (
        <div className="p-6 bg-[#F8FAFC] min-h-screen w-full flex flex-col items-center font-sans">
            <div className="w-full max-w-8xl mx-auto flex flex-col space-y-4 px-2">
                
                {/* ─── BLOCK 1: PAGE TITLE HEADING ─── */}
                <div className="w-full  text-center rounded-lg">
                    <h2 className="text-center text-4xl font-light text-gray-700 mb-8 tracking-tight select-none">
                        Add Event Details
                    </h2>
                </div>

                {/* ─── BLOCK 2: ACTION CONTAINER FOR +ADD NEW BUTTON ─── */}
                <div className="w-full px-1 py-2.5 rounded-lg flex justify-end items-center">
                    <button 
                        type="button"
                        onClick={handleAddNewTrigger}
                        className="bg-[#032167] text-white px-5 py-2 rounded text-xs font-semibold tracking-wide flex items-center gap-2 hover:bg-blue-950 transition-all border-none cursor-pointer active:scale-95 shadow-sm"
                    >
                        <FaPlus size={10} /> Add New
                    </button>
                </div>

                {/* ─── BLOCK 3: TABLE CONTAINER INTEGRATION ─── */}
                <div className="hidden md:block">
                <TableContainer
                    columns={gridHeaders}
                    apiUrl="admin/add-event/"
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    searchPlaceholder="Filter event records instantly..."
                    renderRow={(item, index, srNo) => (
                        <tr key={item.eventid || index} className="border-b border-gray-200 hover:bg-gray-50 transition-colors h-auto text-gray-700 text-xs font-medium bg-white">
                            <td className="p-3 border-r bg-gray-50/50 font-bold text-gray-400 w-[6%] text-center select-none">{srNo}</td>
                            <td className="p-3 border-r text-left pl-5 w-[46%] normal-case font-normal text-gray-600">
                                <ExpandedDescCell text={item.eventdesc} />
                            </td>
                            <td className="p-3 border-r text-left pl-5 w-[36%] uppercase font-bold text-[#032167] tracking-wide">{item.eventtitle || 'N/A'}</td>
                            <td className="w-[12%] p-0">
                                <div className="flex items-center justify-center w-full h-[40px]">
                                    <div className="flex-1 flex justify-center items-center h-full border-r border-gray-200">
                                        <button 
                                            type="button"
                                            onClick={() => handleEditTrigger(item)}
                                            className="text-[#5c9314] hover:text-green-800 border-none bg-transparent cursor-pointer transition-all flex items-center justify-center w-full h-full"
                                            title="Edit Event"
                                        >
                                            <FaEdit size={18} />
                                        </button>
                                    </div>
                                    <div className="flex-1 flex justify-center items-center h-full">
                                        <button 
                                            type="button"
                                            onClick={() => handleRecordDeleteTrigger(item.eventid)}
                                            className="text-[#b0b7bd] hover:text-red-600 border-none bg-transparent cursor-pointer transition-all flex items-center justify-center w-full h-full"
                                            title="Delete Event"
                                        >
                                            <FaTrash size={16} />
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    )}
                />
                </div>
                </div>
                <div className="md:hidden px-2 mt-4">

                <input
                className="w-full border rounded-lg p-3 text-sm"
                placeholder="Search event..."
                value={searchQuery}
                onChange={(e)=>setSearchQuery(e.target.value)}
                />

                </div>
                <div className="md:hidden space-y-4 mt-4 px-2">

                {loadingCards ?

                <div className="text-center py-8">
                Loading...
                </div>

                :

                list.map(item=>(

                <div
                key={item.eventid}
                className="
                bg-white
                rounded-xl
                shadow
                border
                p-4
                w-full
                max-w-full
                overflow-hidden
                "
                >

                <div className="space-y-3 min-w-0">

                <div>

                <p className="text-xs text-gray-500">
                Event Title
                </p>

                <p className="font-semibold break-words">
                {item.eventtitle}
                </p>

                </div>

                <div>

                <p className="text-xs text-gray-500">
                Description
                </p>

                <ExpandedDescCell
                text={item.eventdesc}
                />

                </div>

                <div className="flex justify-end gap-4 pt-2">

                <button
                onClick={()=>handleEditTrigger(item)}
                >
                <FaEdit/>
                </button>

                <button
                onClick={()=>handleRecordDeleteTrigger(item.eventid)}
                >
                <FaTrash/>
                </button>

                </div>

                </div>

                </div>

                ))

                }

                </div>
                <div className="md:hidden flex justify-between items-center py-5">

                <button
                disabled={mobilePage===1}
                onClick={()=>setMobilePage(p=>p-1)}
                >
                Previous
                </button>

                <span>

                Page {mobilePage} of {mobileTotalPages}

                </span>

                <button
                disabled={mobilePage===mobileTotalPages}
                onClick={()=>setMobilePage(p=>p+1)}
                >
                Next
                </button>

                </div>
            

            {/* ─── BLOCK 4: POPUP FORM MODAL ─── */}
           


            {isModalOpen && (
                <div
                className="
                fixed
                inset-0
                z-[6000]
                bg-black/60
                backdrop-blur-sm
                flex
                items-start
                md:items-center
                justify-center
                overflow-y-auto
                p-2
                md:p-6
                "
                >
                    <div
                    className="
                    relative
                    bg-white
                    w-full
                    max-w-5xl
                    rounded-xl
                    shadow-2xl
                    border
                    border-gray-200
                    mt-6
                    md:mt-0
                    max-h-[95vh]
                    overflow-hidden
                    flex
                    flex-col
                    "
                    >
                        
                        {/* ─── HEADER ─── */}
                        <div
                        className="
                        sticky
                        top-0
                        z-20
                        bg-[#032167]
                        flex
                        justify-between
                        items-center
                        px-4
                        py-3
                        border-b
                        "
                        >
                            <h3 className="font-bold text-sm uppercase text-white tracking-wider">
                                {isEditMode ? 'Modify Event Evaluation Details' : 'Add/Edit Event Details'}
                            </h3>
                            <button 
                                type="button" 
                                onClick={() => setIsModalOpen(false)} 
                                className="text-white hover:text-red-300 border-none bg-transparent text-xl cursor-pointer font-bold"
                            >
                                <FaTimes size={18} />
                            </button>
                        </div>

                        {/* ─── FORM ─── */}
                        <form
                        onSubmit={handleFormSubmitAction}
                        className="
                        flex-1
                        overflow-y-auto
                        p-4
                        md:p-6
                        space-y-6
                        text-xs
                        font-semibold
                        uppercase
                        text-gray-700
                        "
                        >
                            
                            {/* Main Fields Grid */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="flex flex-col space-y-1.5">
                                    <label className="font-bold text-gray-700">Event Title (<span className="text-red-500">*</span>):</label>
                                    <input 
                                        type="text" 
                                        className="w-full p-3 border border-gray-300 rounded-lg outline-none bg-gray-50 font-bold text-gray-800 uppercase focus:border-blue-500 transition-all" 
                                        value={formData.eventtitle} 
                                        onChange={(e) => setFormData({...formData, eventtitle: e.target.value})} 
                                        required 
                                    />
                                </div>
                                
                                <div className="flex flex-col space-y-1.5">
                                    <label className="font-bold text-gray-700">Event Description (<span className="text-red-500">*</span>):</label>
                                    <textarea 
                                        rows={3} 
                                        className="w-full p-3 border border-gray-300 rounded-lg outline-none bg-gray-50 font-medium text-gray-700 normal-case resize-none leading-relaxed focus:border-blue-500 transition-all" 
                                        value={formData.eventdesc} 
                                        onChange={(e) => setFormData({...formData, eventdesc: e.target.value})} 
                                        required 
                                    />
                                </div>
                            </div>

                            {/* Attachments Section */}
                            <div className="flex flex-col space-y-3">
                                <div className="flex justify-between items-center">
                                    <label className="font-bold text-gray-700 text-sm">Attachments List</label>
                                    <button 
                                        type="button" 
                                        onClick={addAttachmentRow} 
                                        className="bg-[#2563EB] text-white px-4 py-2 rounded text-[11px] font-bold uppercase hover:bg-blue-700 transition-all shadow-sm"
                                    >
                                        + Add Attachment
                                    </button>
                                </div>

                                <div className="hidden md:block border rounded-lg overflow-hidden">
                                    <div className="md:hidden space-y-4">

                                    {formData.attachments.map((att,idx)=>(

                                    <div
                                    key={idx}
                                    className="border rounded-xl p-4 shadow-sm bg-white"
                                    >

                                    <div className="space-y-3">

                                    <div>

                                    <label className="block mb-1">
                                    Description
                                    </label>

                                    <input
                                    type="text"
                                    value={att.description}
                                    className="w-full border rounded-lg p-2 normal-case"
                                    onChange={(e)=>{

                                    const arr=[...formData.attachments];

                                    arr[idx].description=e.target.value;

                                    setFormData({
                                    ...formData,
                                    attachments:arr
                                    });

                                    }}
                                    />

                                    </div>

                                    <div>

                                    <label className="block mb-1">
                                    Attachment
                                    </label>

                                    {
                                    att.existingFileName ?

                                    <button
                                    type="button"
                                    onClick={()=>window.open(
                                    `${process.env.REACT_APP_MEDIA_URL || 'https://tgsh.geometricsoft.com'}/media/${att.existingFileName}`
                                    )}
                                    className="
                                    text-blue-600
                                    underline
                                    break-all
                                    text-left
                                    "
                                    >

                                    {att.existingFileName}

                                    </button>

                                    :

                                    <input
                                    type="file"
                                    className="w-full text-xs"
                                    onChange={(e)=>{

                                    const arr=[...formData.attachments];

                                    arr[idx].file=e.target.files[0];

                                    setFormData({
                                    ...formData,
                                    attachments:arr
                                    });

                                    }}
                                    />

                                    }

                                    </div>

                                    <div className="flex justify-end">

                                    <button
                                    type="button"
                                    onClick={()=>removeAttachmentRow(idx)}
                                    className="text-red-600"
                                    >

                                    <FaTrash/>

                                    </button>

                                    </div>

                                    </div>

                                    </div>

                                    ))}

                                    </div>

                                    <table className="w-full border-collapse text-center text-[11px]">
                                        <thead className="bg-gray-100 text-gray-700 font-bold uppercase">
                                            <tr>
                                                <th className="p-3 border-r">Description</th>
                                                <th className="p-3 border-r">Attachment</th>
                                                <th className="p-3">Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white text-gray-600">
                                            {formData.attachments.map((att, idx) => (
                                                <tr key={idx} className="border-b border-gray-100 h-[50px]">
                                                    <td className="p-2 border-r">
                                                        <input 
                                                            type="text" 
                                                            className="w-full p-2 border border-gray-200 rounded text-xs" 
                                                            value={att.description}
                                                            onChange={(e) => { 
                                                                let arr = [...formData.attachments]; 
                                                                arr[idx].description = e.target.value; 
                                                                setFormData({...formData, attachments: arr}); 
                                                            }}
                                                            placeholder="Enter description..."
                                                        />
                                                    </td>
                                                    <td className="p-2 border-r">
                                                        {att.existingFileName ? (
                                                            <span onClick={() => window.open(`${process.env.REACT_APP_MEDIA_URL || 'https://tgsh.geometricsoft.com'}/media/${att.existingFileName}`, '_blank')} className="text-blue-600 underline cursor-pointer truncate block max-w-[150px] mx-auto">
                                                                {att.existingFileName}
                                                            </span>
                                                        ) : (
                                                            <input type="file" onChange={(e) => { 
                                                                let arr = [...formData.attachments]; 
                                                                arr[idx].file = e.target.files[0]; 
                                                                setFormData({...formData, attachments: arr}); 
                                                            }} />
                                                        )}
                                                    </td>
                                                    <td className="p-2">
                                                        <button type="button" onClick={() => removeAttachmentRow(idx)} className="text-gray-400 hover:text-red-600 border-none bg-transparent cursor-pointer">
                                                            <FaTrash size={14} />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div
                            className="
                            sticky
                            bottom-0
                            bg-white
                            border-t
                            pt-4
                            pb-2
                            flex
                            justify-end
                            "
                            >
                                <button 
                                    type="submit" 
                                    className="
                                    w-full
                                    md:w-auto
                                    px-10
                                    py-3
                                    bg-[#032167]
                                    text-white
                                    rounded-lg
                                    font-bold
                                    uppercase
                                    tracking-wider
                                    hover:bg-blue-950
                                    transition
                                    "
                                >    Save Details
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddEventDetails;